import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation, EmptyState } from '../../../common';

import './_style.css';

function AlternativeEmptyState({ visible, translate }) {
  if (!visible) {
    return null;
  }

  const text = translate('search.recurrence.exceptions.emptyState');

  return (
    <EmptyState
      icon="232-robot-neutral"
      className="AlternativeEmptyState"
      content={text}
      visible
      centered
    />
  );
}

AlternativeEmptyState.propTypes = {
  visible: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired
};

export default withTranslation(AlternativeEmptyState);
